import React from 'react'
import { Flex, Heading, Textarea, Input, Button } from '@theme-ui/components'

import ContactWidget from '../../General/ContactDetails'
import TextBodySelector from '../../General/TextBodySelector'
import backgroundStylesGradient from '../../../helpers/backgroundStylesGradient'
import componentOptionsSelector from '../../../helpers/componentOptionsSelector'
import MultipleLinksSelector from '../../Links/MultipleLinksSelector'

export default function ContactForm({
  businessData,
  configData,
  options,
  allGeneral,
  variantName,
  poweredImages,
  locationIndex,
  isMultiLocationSite
}) {
  const { name, street, city, state, zip, phone, desc, cover, avatar } = businessData

  const logoPhoto = avatar.imageBaseUrl + '/' + avatar.imagePrefix
  const coverPhoto = cover.imageBaseUrl + '/' + cover.imagePrefix
  const storyId = options.storyId?.[locationIndex]
  const storyTag = options.storyTag?.[locationIndex]

  const {
    titles,
    subtitles,
    texts,
    textType,
    email,
    links,
    contactDetails,
    restrictCharacters,
    images,
    backgroundImages,
    backgroundGradient,
    containerStyles,
    lightOrDarkGradient
  } = componentOptionsSelector(options, locationIndex, storyId, allGeneral, storyTag)

  const formName = `${name}-${city}`

  const styles = containerStyles ? JSON.parse(containerStyles) : {}
  const variant = variantName ? variantName : 'contactFormV1'

  const backgroundStyles =
    backgroundImages?.[locationIndex] || images?.[locationIndex]
      ? backgroundStylesGradient(
          backgroundImages?.[locationIndex] ?? images?.[locationIndex],
          backgroundGradient,
          poweredImages,
          locationIndex,
          lightOrDarkGradient
        )
      : ''

  return (
    <Flex
      variant={`${variant}.container`}
      sx={{
        backgroundImage: backgroundStyles,
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        ...styles
      }}
    >
      {titles && (
        <Heading as="h2" variant={`${variant}.title`} className="title">
          {titles}
        </Heading>
      )}
      {subtitles && (
        <Heading as="h3" variant={`${variant}.subtitle`} className="subtitle">
          {subtitles}
        </Heading>
      )}
      <TextBodySelector
        variantName={`${variantName}`}
        texts={texts}
        textType={textType}
        restrictCharacters={restrictCharacters}
        desc={desc}
      />

      {links?.length > 0 ? (
        <MultipleLinksSelector
          links={links}
          variant={`${variantName}`}
          isMultiLocationSite={isMultiLocationSite}
          city={city}
        />
      ) : null}

      {contactDetails && (
        <>
          <ContactWidget
            phone={phone}
            address={{ name, street, city, state, zip }}
            email={links?.email ?? email ?? ''}
            alternativeGoogleMapLink={configData.alternativeGoogleMapLink}
          />
          <br></br>
        </>
      )}

      <Flex
        as="form"
        variant={`${variantName}.formContainer`}
        name={formName ? formName : 'contactform'} //  this can not be dyanmic form names and details must be static      method='POST'
        method="POST"
        action={`/success/?cover=${coverPhoto}&logo=${logoPhoto}`}
        data-netlify="true"
        data-netlify-honeypot="bot-field"
      >
        <Input type="hidden" name="form-name" value={formName ? formName : 'contactform'} />
        <Input
          variant={`${variantName}.name`}
          name="name"
          type="text"
          id="name"
          mb={3}
          placeholder="Name"
          className="inputField name"
          required
        />
        <Input
          variant={`${variantName}.email`}
          type="phone"
          name="phone"
          id="phone"
          mb={3}
          placeholder="Phone"
          className="inputField email"
        />
        <Input
          variant={`${variantName}.email`}
          type="email"
          name="email"
          id="email"
          mb={3}
          placeholder="Email"
          className="inputField email"
          required
        />

        <Textarea
          name="message"
          id="message"
          variant={`${variantName}.message`}
          rows="6"
          mb={3}
          placeholder="Message"
          className="textField message"
          required
        />
        {isMultiLocationSite ? (
          <Input sx={{ display: 'none !important' }} name="location" id="location" value={city} placeholder={city} />
        ) : (
          ''
        )}
        <Button className="button submitBtn" type="submit">
          Submit
        </Button>
      </Flex>
    </Flex>
  )
}
